import style from './panel-right.scss';
import { preventFromScroll } from './../../../assets/js/prevent-from-scroll';
import {closeLayer} from "Assets/js/close-layer";

const script = () => {
  const cssClass: string = 'PanelRight';
  const cssClassCollapsed: string = 'isCollapsed';
  const cssClassExpanded: string = 'isExpanded';
  const cssExpandedLayer: string = `.isExpanded span[class$='-layer']`;
  const target: string = `.${cssClass}`;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // Test if element is init
    if (elt.dataset[`init${cssClass}`]) {
      return true; // already init go to next iteration
    }
    // Init element
    elt.dataset[`init${cssClass}`] = true;

    // Init close button for close overlay
    const btnClose = document.createElement('span');
    btnClose.classList.add(`${cssClass}-close`);
    btnClose.addEventListener('click', () => {

      // Prevent scroll on panel display
      preventFromScroll();

      elt.classList.add(`${cssClassCollapsed}`);
      elt.classList.remove(`${cssClassExpanded}`);
    });

    elt.querySelector(`.${cssClass}-inner`).appendChild(btnClose);

    // Init layer for background and close overlay
    const layer = document.createElement('span');
    layer.classList.add(`${cssClass}-layer`);
    layer.addEventListener('click', () => {

      // Prevent scroll on panel display
      preventFromScroll();

      elt.classList.add(`${cssClassCollapsed}`);
      elt.classList.remove(`${cssClassExpanded}`);
    });
    elt.appendChild(layer);

    // Init trigger for displaying overlay
    const btnTrigger = document.createElement('span');
    btnTrigger.classList.add(`${cssClass}-trigger`);
    document.querySelector('.SiteHeader-wrapper').appendChild(btnTrigger);
    elt.classList.add(`${cssClassCollapsed}`);

    // Display / Hide Panel
    btnTrigger.addEventListener('click', () => {

      // Prevent scroll on panel display
      preventFromScroll();

      if (!elt.classList.contains(cssClassCollapsed)) {
        elt.classList.remove(cssClassExpanded);
        elt.classList.add(cssClassCollapsed);
      }
      else {

        // Close all expanded layers
        closeLayer(cssExpandedLayer);

        elt.classList.remove(cssClassCollapsed);
        elt.classList.add(cssClassExpanded);
      }
    });
  }
};

export {
  style,
  script,
};
